const SvgEclipse = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 64 64">
    <circle cx={32} cy={32} r={28} stroke="#373737" strokeDasharray="24 4" strokeWidth={8} />
  </svg>;
export default SvgEclipse;